import { Image } from '../Image/Image';
import { Title } from '../Title/Title';
import styles from './UpsaleFeatureList.module.scss';

export const UpsaleFeatureList =({content})=>{
  if(!content){
    return;
  }
  const { title,items } = content;
  
  return (
    <div className={styles.wrapper} >
      {title && <Title dangerouslySetInnerHTML={{ __html:title }} tag="h2" className={styles.title}/>}
      {items &&
      items.map((box, index) => {
        return (
          <div className={styles.box} key={index}>
            {box.icon && <Image src={box.icon} className={styles.icon}/>}
            {box.text && <div className={styles.text}>{box.text}</div>}
          </div>
        );
      })
      }
    </div>
  )
}